import type {
  CourseSnapshot,
  RoundParticipantInput,
  RoundRulesSnapshot,
  CourseHoleSnapshot,
} from "./round-types.js";

/** The PH already applies to these holes; this does not convert HI or 18-hole PH. */
export function allocateHandicapStrokes(
  holes: CourseHoleSnapshot[],
  playingHandicap: number,
): number[] {
  const strokes = new Array<number>(holes.length).fill(0);
  const whole = Math.trunc(playingHandicap);
  if (whole === 0 || holes.length === 0) return strokes;
  const sign = whole > 0 ? 1 : -1;
  const absolute = Math.abs(whole);
  const base = Math.floor(absolute / holes.length);
  strokes.fill(sign * base);
  const extras = absolute - base * holes.length;
  const ordered = holes
    .map((hole, index) => ({ index, strokeIndex: hole.strokeIndex }))
    .sort((left, right) =>
      sign > 0
        ? left.strokeIndex - right.strokeIndex
        : right.strokeIndex - left.strokeIndex,
    );
  for (let index = 0; index < extras; index += 1) {
    const target = ordered[index]!.index;
    strokes[target] = (strokes[target] ?? 0) + sign;
  }
  return strokes;
}

/** Legacy v2 only. New v3 creation never derives Playing Handicap from HI. */
export function legacyPlayingHandicap(
  participant: RoundParticipantInput,
  course: CourseSnapshot,
  rules: RoundRulesSnapshot,
): number {
  if (rules.handicapMode === "off" || participant.handicapIndex === null)
    return 0;
  const coursePar = course.holes.reduce((sum, hole) => sum + hole.par, 0);
  return Math.round(
    participant.handicapIndex * (course.slope! / 113) +
      (course.rating! - coursePar),
  );
}
